module.exports = __webpack_public_path__ + "static/media/15_l_shirma_0.52_44.81.e5d5cdbd.png";